import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        /*
         * Portals to body, so it must outrank dialogs to work inside one — see ui/dialog.tsx.
         *
         * **`pointer-events-auto` ist die zweite Hälfte desselben Gedankens.** Ein modaler Radix-
         * Dialog setzt `pointer-events: none` am `body` und hebt es nur für seinen eigenen Inhalt
         * wieder auf. Ein Popover hängt aber am `body`, nicht im Dialog — es erbt die Sperre und
         * steht sichtbar, aber unanklickbar da: Der Klick fällt hindurch auf das, was darunter
         * liegt. Gemessen am 17.09.2026 im Eingabeschema eines Prompt-Werkzeugs: Der Klick auf
         * „PDF Files" setzte nichts und öffnete stattdessen die Liste darunter. Betroffen war
         * jedes Auswahlfeld in jedem Dialog.
         *
         * Ein geöffnetes Popover soll immer bedienbar sein; außerhalb eines Dialogs ändert die
         * Zeile nichts, weil dort ohnehin niemand die Zeigerereignisse sperrt.
         */
        "pointer-events-auto z-[10100] w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };
